<template>
	<div>{{ time }}</div>
</template>

<script>
export default {
	data() {
		return {
			time: '',
			interval: null
		};
	},
	mounted() {
		this.interval = setInterval(this.timer, 1000);
		this.timer();
	},
	beforeDestroy() {
		clearInterval(this.interval);
	},
	methods: {
		timer() {
			this.time = new Date().toLocaleString('en-US', {
				hour: 'numeric',
				minute: 'numeric',
				hour12: true
			});
		}
	}
};
</script>

<style></style>
